import './App.css';
import { BrowserRouter } from "react-router-dom";
import { persistor, store } from "./Setup/Redux/Store";
import { Provider } from "react-redux";
import React from "react";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from 'react-helmet-async';
import { PublicRoutes } from "./Routes/PublicRoutes";
import { PrivateRoutes } from "./Routes/PrivateRoutes";
import { ScrollToTop, ConsentChecker } from "./Components";

const App = () => {

    return (
        <HelmetProvider>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <BrowserRouter
                        future={{
                            v7_startTransition: true,
                            v7_relativeSplatPath: true,
                        }}
                    >
                        <ScrollToTop />
                        <ConsentChecker />
                        <PublicRoutes />
                        <PrivateRoutes />
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </HelmetProvider>
    );
}

export default App;
